import { useQuery } from "@tanstack/react-query";
import { ContainerTypeService } from "./_request";

/**
 * Container Dimension
 * @param params
 * @returns
 */

export const useQueryContainerUnitsSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getContainerUnits"],
    queryFn: async () =>
      await ContainerTypeService.getContainerUnits(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Container category
 * @param params
 * @returns
 */

export const useQueryContainerCategorySelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getContainerCategory"],
    queryFn: async () =>
      await ContainerTypeService.getContainerCategories(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Container types
 * @param params
 * @returns
 */

export const useQueryContainerTypeSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getContainerType"],
    queryFn: async () =>
      await ContainerTypeService.getContainerTypeForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};